import React, { useEffect } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies, import/no-unresolved
import { QueryClient } from '@tanstack/react-query'
// eslint-disable-next-line import/no-extraneous-dependencies, import/no-unresolved
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
// eslint-disable-next-line import/no-extraneous-dependencies, import/no-unresolved
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { Provider } from 'react-redux'
import { ThemeProvider } from '@mui/material/styles'
import store from './redux/store'
import { muiTheme } from './muiTheme'
import './css/App.css'
import './css/Mobile.css'
import Routes from './Routes'
import GlobalLoaderHost from './components/commons/GlobalLoaderHost'
import { TenantProvider } from './context/TenantContext'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            cacheTime: 1000 * 60 * 60 * 24, // 24 hours
            staleTime: 0, // 0 minutes so it always refetches in background when online
        },
    },
})

const persister = createSyncStoragePersister({
    storage: window.localStorage,
})

function App() {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        const ltiToken = params.get('ltiToken')
        if (ltiToken) {
            document.cookie = `jwt=${ltiToken}; path=/`
            window.location.href =
                window.location.origin + window.location.pathname
        }

        const applyTheme = (mode) => {
            const root = document.documentElement
            root.setAttribute('data-theme', mode === 'dark' ? 'dark' : 'light')
        }

        const syncTheme = () => {
            const state = store.getState()
            const mode = state?.theme?.mode || 'light'
            applyTheme(mode)
            if (typeof window !== 'undefined') {
                window.localStorage.setItem('themeMode', mode)
            }
        }

        syncTheme()
        const unsubscribe = store.subscribe(syncTheme)

        return () => unsubscribe()
    }, [])

    return (
        <PersistQueryClientProvider
            client={queryClient}
            persistOptions={{ persister }}
        >
            <Provider store={store}>
                <ThemeProvider theme={muiTheme}>
                    <div className="App">
                        <GlobalLoaderHost />
                        <TenantProvider>
                            <Routes />
                        </TenantProvider>
                    </div>
                </ThemeProvider>
            </Provider>
        </PersistQueryClientProvider>
    )
}

export default App
